import { Component, Inject, OnInit } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { MatDialogRef } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements OnInit {
  public chosenLanguage = '';
  public options = [];

  constructor(
    public dialogRef: MatDialogRef<LanguagePickerComponent>,
    private dateAdapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private dateLocale: string,
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService
  ) { }

  ngOnInit(): void {
    this.chosenLanguage = this.i18NextService.language;
    this.options = [
      { id: 'es-ES', name: 'LANGUAGE.SPANISH' },
      { id: 'pt-PT', name: 'LANGUAGE.PORTUGUESE' }
    ];
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public save(): void {
    this.i18NextService.changeLanguage(this.chosenLanguage).then(() => {
      sessionStorage.setItem('i18nlang', this.chosenLanguage);
      document.documentElement.lang = this.chosenLanguage;
      this.dateLocale = this.chosenLanguage;
      this.dateAdapter.setLocale(this.chosenLanguage);
    });
    this.dialogRef.close();
  }

  public changeLanguage(option): void {
    this.chosenLanguage = option.id;
  }
}
